import React from 'react';
import { Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SectionHero from '../Helpers/SectionHero';
import ServiceCard from '../Helpers/ServiceCard';
import energiaSolar from '../../assets/images/services/energia_solar.jpg';
import { useLanguage } from '../../i18n/LanguageContext';

const serviceIcons = ['fa-ruler-combined', 'fa-solar-panel', 'fa-hand-holding-dollar', 'fa-chart-line'];

const OtrosServicios = () => {
    const { t } = useLanguage();
    const servicios = t('energias.servicios').map((s, i) => ({ ...s, icon: serviceIcons[i] }));

    return (
        <>
            {/* Hero */}
            <SectionHero badge={t('energias.badge')} title={t('energias.title')} image={energiaSolar} imagePos="center">
                <p className="text-blue-100 text-lg md:text-xl">
                    {t('energias.subtitle')}
                </p>
            </SectionHero>

            {/* Servicios destacados — fondo claro, lenguaje visual alineado al inicio */}
            <section
                id="energias-limpias"
                className="relative overflow-hidden py-24 scroll-mt-24"
                style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
            >
                <div
                    className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
                    style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
                ></div>
                <div className="contain relative z-10">
                    <div className="text-center max-w-2xl mx-auto mb-16" data-aos="fade-up">
                        <h2 className="text-salient-primary font-bold text-4xl mb-4">{t('energias.sectionTitle')}</h2>
                        <span className="title-underline mx-auto"></span>
                        <p className="text-gray-600 mt-4">
                            {t('energias.sectionSubtitle')}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 items-stretch">
                        {servicios.map((item, index) => (
                            <ServiceCard
                                key={index}
                                index={index}
                                icon={item.icon}
                                title={item.title}
                                text={item.text}
                                delay={(index % 4) * 100}
                            />
                        ))}
                    </div>

                    <div className="text-center mt-12" data-aos="fade-up">
                        <Link to="/contact" className="btn btn-primary">{t('energias.ctaButton')}</Link>
                    </div>
                </div>
            </section>
        </>
    );
};

export default OtrosServicios;
